import { Component } from '@angular/core';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {ToastComponent} from "./components/common/toast/toast.component";
import {ToastService} from "./components/common/toast/toast.service";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = '';

  get toasts() {
    return this.toastService.toasts;
  }

  constructor(
    private toastService: ToastService
  ) {}
}
